import styled from 'styled-components'
import { Button } from '@/components/button'

type SocialProps = {
  id: string
  onClick: (e: React.MouseEvent<HTMLElement>) => void
  children: React.ReactNode
}

const StyledButton = styled(Button)<SocialProps>`
  font-size: 14px;
  line-height: 16px;
  min-width: unset;
`

const SocialButton: React.FC<SocialProps> = ({ children, ...rest }) => {
  return (
    <StyledButton type="submit" {...rest} width="100%" theme="secondary">
      {children}
    </StyledButton>
  )
}

export default SocialButton
